const moduleLoader = {
    namespaced: true,
    state: {
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        }
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
    },
    actions: {
        getState({ commit }, state) {
            commit('setLoader', state);
        }
    }
};
export default moduleLoader;
